import type { PageTour } from '../types';

export const adminTour: PageTour = {
  id: 'admin',
  label: 'Admin Tour',
  steps: [
    {
      target: '[data-tour="admin-header"]',
      title: 'Administration',
      content: 'Manage your organization\'s settings, users, policies, and configurations from this admin panel.',
    },
    {
      target: '[data-tour="admin-tabs"]',
      title: 'Admin Sections',
      content: 'Navigate between different admin areas — user management, policies, settings, and more.',
    },
    {
      target: '[data-tour="admin-content"]',
      title: 'Admin Content',
      content: 'Each section lets you configure a specific part of your organization. Changes take effect immediately.',
    },
  ],
};
